import { useMemo } from 'react';

import PropTypes from 'prop-types';

import { Indicator } from './Indicator';
import * as Styled from './ProgressBar.styles';

function isCompleted(indicatorIndex, currentSlide, isAutoplay) {
  return indicatorIndex < currentSlide || (indicatorIndex <= currentSlide && !isAutoplay);
}

function ProgressBar({
  autoplayDuration = 5000,
  currentSlide = 0,
  isAutoplay = true,
  totalSlides = 1
}) {
  const indicators = useMemo(() => [...Array(totalSlides).keys()], [totalSlides]);

  return (
    <Styled.Root gap={1} horizontal>
      {indicators.map((i) => (
        <Indicator
          key={`slide_${i}`}
          isCompleted={isCompleted(i, currentSlide, isAutoplay)}
          isInProgress={i === currentSlide}
          progressDuration={autoplayDuration}
        />
      ))}
    </Styled.Root>
  );
}

ProgressBar.propTypes = {
  autoplayDuration: PropTypes.number,
  currentSlide: PropTypes.number,
  isAutoplay: PropTypes.bool,
  totalSlides: PropTypes.number
};

export default ProgressBar;
